import { ElevatorStandardDirectionDisplay } from "./ElevatorStandardDirectionDisplay";
import { ElevatorStandardFloorDisplay } from "./ElevatorStandardFloorDisplay";
import { cn } from "@/core/helpers/cn";

export function ElevatorStandardHeader({
  size,
  currentFloor,
  targetFloor,
}: {
  size: "sm" | "lg";
  currentFloor: number;
  targetFloor: number;
}) {
  return (
    <div className={cn("flex justify-between mb-[40px]")}>
      <ElevatorStandardFloorDisplay size={size} currentFloor={currentFloor} />
      <ElevatorStandardDirectionDisplay targetFloor={targetFloor} currentFloor={currentFloor} />
    </div>
  );
}
